import {
  Center,
  Flex,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text,
} from "@chakra-ui/react";
import { useContext } from "react";
import { FormattedMessage } from "react-intl";

import { SIDEBAR_CLOSED_PX, SIDEBAR_OPEN_PX } from "@nens/ranalib";
import { TenantContext } from "@nens/ranalib";

import { Profile } from "@/lib/profile";
import { getCompleteName } from "@/utils/get-complete-name";

import { LogoutModal } from "./logout-modal";
import { SwitchOrganisationsModal } from "./switch-organisations-modal";

type SidebarProfilePopupProps = { sidebarIsOpen: boolean };

export function SidebarProfilePopup({ sidebarIsOpen }: SidebarProfilePopupProps) {
  const { user } = useContext(TenantContext);
  return (
    <Popover placement="right-start">
      <PopoverTrigger>
        <Flex maxW={`${SIDEBAR_OPEN_PX}px`} cursor="pointer" w="fit" alignItems="center">
          <Center flexShrink={0} w={`${SIDEBAR_CLOSED_PX}px`}>
            <Profile noModal user="self" />
          </Center>
          {sidebarIsOpen && (
            <Text mx={1} whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
              {getCompleteName(user)}
            </Text>
          )}
        </Flex>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader color="initial">
          <Flex pb={3} flexDir="column" alignItems="center">
            <Profile boxSize={16} user="self">
              <Text pt={3}>
                <FormattedMessage
                  id="profile.open_profile_settings"
                  defaultMessage="Open profile settings"
                />
              </Text>
            </Profile>
          </Flex>
        </PopoverHeader>
        <PopoverHeader color="initial">
          <Flex py={3} flexDir="column" alignItems="center">
            <SwitchOrganisationsModal />
          </Flex>
        </PopoverHeader>
        <PopoverBody color="initial">
          <Flex py={3} flexDir="column" alignItems="center">
            <LogoutModal />
          </Flex>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
